<template>
    <ion-page>
        <standard-header title="LOGIN" align="middle"/>
        <ion-content>
            <ion-card>
                <div class="login-logo ion-padding" align="middle">
                    <img src="/assets/raf.png" style="max-height: 300px">
                </div>

                <form novalidate>
                    <ion-list>
                        <ion-item class="ion-padding">
                            <ion-label position="stacked" color="primary">Username *</ion-label>
                            <ion-input
                                ref="username"
                                v-model="email"
                                name="email"
                                type="email"
                                spellcheck="false"
                                autocapitalize="off"
                                required
                                :autofocus="true"
                                @keypress.enter="focus('password')"
                            />
                        </ion-item>

                        <ion-item class="ion-padding">
                            <ion-label position="stacked" color="primary">Password *</ion-label>
                            <ion-input
                                ref="password"
                                v-model="password"
                                name="password"
                                type="password"
                                required
                                @keypress.enter="login()"
                            />
                        </ion-item>
                    </ion-list>

                    <ion-row responsive-sm>
                        <ion-col>
                            <ion-button @click="login" expand="block">Login</ion-button>
                        </ion-col>
                    </ion-row>
                </form>
            </ion-card>
        </ion-content>
    </ion-page>
</template>

<script>
import {IonContent, IonPage} from '@ionic/vue';
import {IonItem, IonList, IonLabel, IonButton, IonInput, IonRow, IonCol, IonCard} from '@ionic/vue';

import StandardHeader from "@/components/StandardHeader.vue";

import EventBus from "@/EventBus";
import Storage from '@/services/Storage';
import router from "@/router";
import {Capacitor} from "@capacitor/core";

export default {
    name: 'Login',
    inject: ['$http', '$validationAlert', '$toast'],
    components: {
        IonPage,
        IonContent,
        StandardHeader,
        IonItem,
        IonList,
        IonLabel,
        IonButton,
        IonInput,
        IonRow,
        IonCol,
        IonCard
    },
    computed: {
        payload() {
            return {
                email: this.email,
                password: this.password,
                onesignal: this.onesignal
            }
        }
    },
    data() {
        return {
            onesignal: {},
            password: '',
            email: ''
        }
    },
    mounted() {
        if (Capacitor.platform !== 'web') {
            window["plugins"].OneSignal.getIds(ids => {
                this.onesignal = ids;
            });
        }
    },
    methods: {
        focus(field) {
            this.$refs[field].$el.setFocus();
        },
        login() {
            const storage = new Storage();
            EventBus().emitter.emit('loading', true);
            this.$http
                .post('/api/auth/login', {...this.payload}, {params: {include:'permissions,api_token,roles'}})
                .then(response => {
                    EventBus().emitter.emit('loading', false);
                    storage.set('user', response.data);
                    router.replace({name: 'home', force: true});
                    EventBus().emitter.emit('auth.login', response.data);
                    this.$toast.success("You have logged in successfully!");
                    if (Capacitor.platform !== 'web') {
                        this.setupOnesignal();
                    }
                })
                .catch(error => {
                    EventBus().emitter.emit('loading', false);
                    this.$validationAlert(error);
                })
        }
    },
    setup() {
        return {}
    }
}
</script>

<style scoped>

</style>
